// 重定向到登入頁面
/**
 * 重定向到登入頁面
 * @param identityServiceUrl Identity Service 的 URL
 * @param currentUrl 當前 URL (可選，預設為 window.location.href)
 */
export function redirectToLogin(identityServiceUrl, currentUrl) {
    const url = new URL(currentUrl || window.location.href);
    // 清掉 SSO 一次性代碼（已用過或已過期，不要帶回登入後的網址）
    url.searchParams.delete('auth_code');
    const cleanUrl = url.toString();
    const redirectUrl = encodeURIComponent(cleanUrl);
    // 重定向到登入頁面
    window.location.href = `${identityServiceUrl}/auth/login?redirect=${redirectUrl}`;
}
